<div class="container">
  <table>
    <caption>
      <h1>Detailed Feature Comparison</h1>
    </caption>
    <thead>
      <tr >
        <th class="main-head" scope="col">Feature</th>
        <th class="main-head" scope="col">Free</th>
        <th class="main-head" scope="col">Basic</th>
        <th class="main-head" scope="col">Start Up</th>
        <th class="main-head" scope="col">Growth</th>
      </tr>
    </thead>
    <tbody>
      <tr class="check-tr">
        <td data-label="Feature">Create Short Link</td>
        <td data-label="Free"><b>20</b></td>
        <td data-label="Basic"><b>2000</b></td>
        <td data-label="Start Up"><b>5000</b></td>
        <td data-label="Growth"><b>Unlimited</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Create Bio Link</td>
        <td data-label="Free"><b>1</b></td>
        <td data-label="Basic"><b>2</b></td>
        <td data-label="Start Up"><b>5</b></td>
        <td data-label="Growth"><b>Unlimited</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link History</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link Reporting</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Advanced Performance Dashboard</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Data Export </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">State-Level Data</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Device-Type Tracking</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Browser-Type Tracking</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Platform-Type Tracking</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Hourly Analytics </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Weekly Analytics </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Monthly Analytics </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Custom Analytics </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Yearly Analytics </td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>

      <tr class="feature">
        <th scope="col" colspan="5">Bio Link</th>
      </tr>

      <tr class="check-tr">
        <td data-label="Feature">Classic and Pro layout</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Pre-Designed Themes</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Custom Background Colors</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Button & Font Styles</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Profile Image Upload</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Background Top Image Upload</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Background Bottom Image Upload</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Add URL to Profile Image</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Add URL to Bio-Link Images</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Add Text on Bio-Link</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Add Description on Bio-Link</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Description of Bio-Link upto 250 Characters</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">YouTube Video Embed </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">SoundCloud Video Embed</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Vimeo Video Embed </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Spotify Embed</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Twitch Embed</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">TikTok Embed</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link-in-bio Social Icons</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link-in-bio QR Code</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Advanced Performance Dashboard</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Export Bio-Link CSV</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Password Protection</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Allow to share bio-link directly on twitter</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Allow to share bio-link directly on Facebook</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Allow to share Link directly on twitter</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Allow to share Link directly on Facebook</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Blue Tick for Bio Link</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Social Media Colourful Icons</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>

      <tr class="feature">
        <th scope="col" colspan="5">QR Codes</th>
      </tr>

      <tr class="check-tr">
        <td data-label="Feature">QR Codes</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">QR Code Analytics</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">QR Code Editing Dashbord</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Download Format(.png)</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">QR Codes in Diffrent Colors</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      
      <tr class="feature">
        <th scope="col" colspan="5">Customer Success</th>
      </tr>

      <tr class="check-tr">
        <td data-label="Feature">Help Center</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Help Documents [ PDF and Video ]</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Account Management</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Chatbot Support on WhatsApp</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <!-- <tr class="check-tr">
        <td data-label="Feature">Chatbot Support on Telegram</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr> -->
      <tr class="check-tr">
        <td data-label="Feature">Chatbot Support on Twitter</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Chatbot Support on Facebook</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Chatbot Support on Instagram</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Money Back Guarantee</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Light Mode Interface </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Dark Mode Interface </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Blogs</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Multi- Currency Pricing </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      
      <tr class="feature">
        <th scope="col" colspan="5">Link Management</th>
      </tr>

      <tr class="check-tr">
        <td data-label="Feature">Short Links</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Branded Links</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Branded Link Redirects</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link Redirects</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link Clicks</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Bulk Shortening</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link Export</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Multiple Short links for one URL</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Uptime Service Level Agreement (SLA)</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Editable Destination URL</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Custom URL Slug</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link Click Expiration and redirect</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Bio-Link Click Expiration and redirect </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link Search</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Bio-Link Search</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link Schedule for specific period</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Bio-Link Schedule for specific period</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Password Protection</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Tags to links</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link Description</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Onboarding & Setup</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Support</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Device Targeting</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Location Targeting</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Platform Targeting</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Create Tracking Pixel</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><b>5</b></td>
        <td data-label="Start Up"><b>10</b></td>
        <td data-label="Growth"><b>Unlimited</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Create Link Group </td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><b>5</b></td>
        <td data-label="Start Up"><b>10</b></td>
        <td data-label="Growth"><b>Unlimited</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Create Link Overlay</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><b>5</b></td>
        <td data-label="Start Up"><b>10</b></td>
        <td data-label="Growth"><b>Unlimited</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Create Custom Domain</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><b>2</b></td>
        <td data-label="Growth"><b>10</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Workspaces</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><b>2</b></td>
        <td data-label="Growth"><b>10</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">API Access Request</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><b>150000 / Day</b></td>
        <td data-label="Growth"><b>150000 / Day</b></td>
      </tr>
      
    </tbody>
    <!-- <tbody>
      <tr class="feature">
        <th scope="col" colspan="5">Limit</th>
      </tr>
      <tr class="check-tr">
        <td data-label="Limit">Create Short Link</td>
        <td data-label="Free"><b>20</b></td>
        <td data-label="Basic"><b>2000</b></td>
        <td data-label="Start Up"><b>5000</b></td>
        <td data-label="Growth"><b>Unlimited</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Limit">Create Bio Link</td>
        <td data-label="Free"><b>1</b></td>
        <td data-label="Basic"><b>2</b></td>
        <td data-label="Start Up"><b>5</b></td>
        <td data-label="Growth"><b>Unlimited</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Limit">Create Tracking Pixel</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><b>5</b></td>
        <td data-label="Start Up"><b>10</b></td>
        <td data-label="Growth"><b>Unlimited</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Limit">Create Link Group</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><b>5</b></td>
        <td data-label="Start Up"><b>10</b></td>
        <td data-label="Growth"><b>Unlimited</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Limit">Create Link Overlay</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><b>5</b></td>
        <td data-label="Start Up"><b>10</b></td>
        <td data-label="Growth"><b>Unlimited</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Limit">Create Custom Domain</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><b>2</b></td>
        <td data-label="Growth"><b>10</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Limit">Workspace</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><b>2</b></td>
        <td data-label="Growth"><b>10</b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Limit">API Access</td>
        <td data-label="Free"><b><i class="fa fa-times" aria-hidden="true"></i></b></td>
        <td data-label="Basic"><b><i class="fa fa-times" aria-hidden="true"></i></b></td>
        <td data-label="Start Up"><b><i class="fa fa-times" aria-hidden="true"></i></b></td>
        <td data-label="Growth"><b><i class="fa fa-check" aria-hidden="true"></i></b></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Limit">Bluetick</td>
        <td data-label="Free"><b><i class="fa fa-times" aria-hidden="true"></i></b></td>
        <td data-label="Basic"><b><i class="fa fa-check" aria-hidden="true"></i></b></td>
        <td data-label="Start Up"><b><i class="fa fa-check" aria-hidden="true"></i></b></td>
        <td data-label="Growth"><b><i class="fa fa-check" aria-hidden="true"></i></b></td>
      </tr>
      <tr class="feature">
        <th scope="col" colspan="5">Link Management</th>
      </tr>
      <tr class="check-tr">
        <td data-label="Link Management">Short Links</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link Management">Branded Links</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link Management">Branded Link Redirects</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link Management">Link Redirects</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link Management">Link Clicks</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link Management">Bulk Shortening</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link Management">Link Export</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="feature">
        <th scope="col" colspan="5">QR Codes</th>
      </tr>
      <tr class="check-tr">
        <td data-label="QR Codes">QR Codes</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="QR Codes">Colors</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="QR Codes">Download Format(.png)</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="QR Codes">Advanced Performance Dashboard</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="feature">
        <th scope="col" colspan="5">Bio Link</th>
      </tr>
      <tr class="check-tr">
        <td data-label="Link-in-bio">Branding</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link-in-bio">Pre-Designed Themes</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link-in-bio">Custom Background Colors</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link-in-bio">Button & Font Styles</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link-in-bio">Profile & Background Image Upload</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link-in-bio">Link-in-bio Social Icons</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link-in-bio">Link-in-bio QR Code</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Link-in-bio">Advanced Performance Dashboard</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <th scope="col">Custom Domain Essentials</th>
        <th scope="col"></th>
        <th scope="col"></th>
        <th scope="col"></th>
      </tr>
      <tr class="check-tr">
        <td data-label="Custom Domain Essentials">Complimentary Custom Domain*</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Custom Domain Essentials">Domain Finder</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Custom Domain Essentials">Domain 1-Step Setup</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Custom Domain Essentials">Domain Guard </td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Custom Domain Essentials">Domain Root Router</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Custom Domain Essentials">Domain 505 Error Fixer</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <th scope="col">Campaign Management</th>
        <th scope="col"></th>
        <th scope="col"></th>
        <th scope="col"></th>
      </tr>
      <tr class="check-tr">
        <td data-label="Campaign Management">Campaigns</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Campaign Management">UTM Builder</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Campaign Management">Bulk Import to Campaigns</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Campaign Management">Export of Campaign Data</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Campaign Management">Social Posting</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Campaign Management">Parameter Passing</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr> 
      <tr class="feature">
        <th scope="col" colspan="5">Feature</th>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link History</td>
        <td data-label="Free"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Link Reporting</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Advanced Performance Dashboard</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Data Export </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">State-Level Data</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Feature">Device-Type Tracking</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <th scope="col">Data Delivery</th>
        <th scope="col"></th>
        <th scope="col"></th>
        <th scope="col"></th>
      </tr>
      <tr class="check-tr">
        <td data-label="Data Delivery">API Rate Limit</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Data Delivery">Webhooks</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Data Delivery">Integrations</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Data Delivery">SLA Uptime</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <th scope="col">Platform Access</th>
        <th scope="col"></th>
        <th scope="col"></th>
        <th scope="col"></th>
      </tr>
      <tr class="check-tr">
        <td data-label="Platform Access">Web Browser Extensions</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Platform Access">API v5</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Platform Access">Device-Specific Web Access</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Platform Access">Mobile App</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <th scope="col">Admin check-trs</th>
        <th scope="col"></th>
        <th scope="col"></th>
        <th scope="col"></th>
      </tr>
      <tr class="check-tr">
        <td data-label="Admin check-trs">Group Permissions</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Admin check-trs">User Management </td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Admin check-trs">SSO Self-Service Setup</td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Admin check-trs">2-Factor Authentication (2FA) </td>
        <td data-label="Basic"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-times" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-times" aria-hidden="true"></i></td>
      </tr>
      <tr class="feature">
        <th scope="col" colspan="5">Customer Success</th>
      </tr>
      <tr class="check-tr">
        <td data-label="Customer Success">Help Center</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Customer Success">Support </td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Customer Success">Account Management</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
      <tr class="check-tr">
        <td data-label="Customer Success">Onboarding & Setup</td>
        <td data-label="Free"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Basic"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Start Up"><i class="fa fa-check" aria-hidden="true"></i></td>
        <td data-label="Growth"><i class="fa fa-check" aria-hidden="true"></i></td>
      </tr>
    </tbody> -->
  </table>
</div>
